import { render } from "./EventInfo.vue?vue&type=template&id=58f8acdc&scoped=true"
import script from "./EventInfo.vue?vue&type=script&lang=js"
export * from "./EventInfo.vue?vue&type=script&lang=js"

import "./EventInfo.vue?vue&type=style&index=0&id=58f8acdc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f8acdc"]])

export default __exports__